import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {

  getCouponCodeApi
} from 'api';
import {
  Icon,
  IconButton
} from '@material-ui/core';


const CouponCode = (props) => {
  const { coupon_type, couponCodes, copyCode, rule_id } = props;
  const dispatch = useDispatch();
  const [isCouponCodeVisible, setIsCouponCodeVisible] = useState(false);


  return (
    <>
      {coupon_type == 'SPECIFIC_COUPON' &&
      ((isCouponCodeVisible && !!couponCodes) ?
        <div className="flex items-center">
          <div className="flex flex-column">
            {
              couponCodes.map((code, ind) => (
                <div key={ind}>
                  <span>{code}</span>
                  <IconButton
                    title="Copy"
                    onClick={() => copyCode(code)}
                  >
                    <Icon>content_copy</Icon>
                  </IconButton>
                </div>
              ))
            }
          </div>
          <IconButton
            onClick={() => {
              setIsCouponCodeVisible(false);
            }}
          >
            <Icon>visibility_off</Icon>
          </IconButton>
        </div>
        :
        <div className="flex items-center">
          <span>*****</span>
          <IconButton
            onClick={() => {
              getCouponCodeApi({dispatch, rule_id});
              setIsCouponCodeVisible(true);
            }}
          >
            <Icon>visibility</Icon>
          </IconButton>
        </div>
      )
      }
      {coupon_type !== 'SPECIFIC_COUPON' && <span>Coupon code absent</span>}
    </>
  );
};

export default CouponCode;
